var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutions1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 310,
    viewBox: "0 0 409 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4017_131)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.879395,
    y: 0.3125,
    width: 408,
    height: 309,
    rx: 12,
    fill: "url(#paint0_linear_4017_131)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4017_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.879 49.3125H38.8794V309.312H370.879V49.3125Z",
    fill: "#BCCCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.879 78.7988H38.8794V309.313H370.879V78.7988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7179 68.3919C53.4101 68.3919 55.5925 66.2175 55.5925 63.5353C55.5925 60.8531 53.4101 58.6787 50.7179 58.6787C48.0257 58.6787 45.8432 60.8531 45.8432 63.5353C45.8432 66.2175 48.0257 68.3919 50.7179 68.3919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1358 63.5353C76.1358 66.137 74.0467 68.3919 71.2611 68.3919C68.6497 68.3919 66.3865 66.3105 66.3865 63.5353C66.3865 60.9335 68.4756 58.6787 71.2611 58.6787C74.0467 58.6787 76.1358 60.7601 76.1358 63.5353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8532 63.5353C96.8532 66.137 94.764 68.3919 91.9785 68.3919C89.3671 68.3919 87.1038 66.3105 87.1038 63.5353C87.1038 60.9335 89.193 58.6787 91.9785 58.6787C94.5899 58.6787 96.8532 60.7601 96.8532 63.5353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.673 72.2077H120.008C115.481 72.2077 111.651 68.5653 111.651 63.8822C111.651 59.3725 115.307 55.5566 120.008 55.5566H256.673C261.199 55.5566 265.029 59.1991 265.029 63.8822C265.029 68.3919 261.199 72.2077 256.673 72.2077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.684 72.2077H285.921C281.394 72.2077 277.564 68.5653 277.564 63.8822C277.564 59.3725 281.22 55.5566 285.921 55.5566H350.684C355.211 55.5566 359.041 59.1991 359.041 63.8822C359.041 68.3919 355.211 72.2077 350.684 72.2077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.379 99.9596H71.3419C68.0282 99.9596 65.3419 102.646 65.3419 105.96V136.672C65.3419 139.985 68.0282 142.672 71.3419 142.672H177.379C180.692 142.672 183.379 139.985 183.379 136.672V105.96C183.379 102.646 180.692 99.9596 177.379 99.9596Z",
    fill: "#BCCCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56 113.119H72.2188V118.323H169.56V113.119Z",
    fill: "#9CB4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.764 124.308H72.2188V129.512H136.764V124.308Z",
    fill: "#9CB4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.583 200.079H224.546C221.232 200.079 218.546 202.765 218.546 206.079V245.59C218.546 248.904 221.232 251.59 224.546 251.59H330.583C333.896 251.59 336.583 248.904 336.583 245.59V206.079C336.583 202.765 333.896 200.079 330.583 200.079Z",
    fill: "#BCCCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.068 211.002H225.927V216.206H281.068V211.002Z",
    fill: "#9CB4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.269 223.233H225.927V228.436H323.269V223.233Z",
    fill: "#9CB4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.214 235.464H225.927V240.667H297.214V235.464Z",
    fill: "#9CB4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.864 272.672H68.3419C66.6851 272.672 65.3419 274.015 65.3419 275.672V292.258C65.3419 293.915 66.6851 295.258 68.3419 295.258H310.864C312.521 295.258 313.864 293.915 313.864 292.258V275.672C313.864 274.015 312.521 272.672 310.864 272.672Z",
    fill: "#BCCCFD"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4017_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.518 276.188L324.955 283.75",
    stroke: "#7999FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.518 276.188L327.705 289.938L324.955 283.75L318.768 281L332.518 276.188Z",
    stroke: "#7999FB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4017_131",
    x1: 22.8794,
    y1: -18.6059,
    x2: 387.615,
    y2: 395.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEF2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F9FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4017_131"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.879395,
    y: 0.3125,
    width: 408,
    height: 309,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4017_131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8794 61.3125C38.8794 54.6851 44.252 49.3125 50.8794 49.3125H358.879C365.507 49.3125 370.879 54.6851 370.879 61.3125V309.312H38.8794V61.3125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4017_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(317.393 274.812)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutions1);
export default __webpack_public_path__ + "static/media/solutions1.3f4488a4cb77754a2f419e9858e3500f.svg";
export { ForwardRef as ReactComponent };